class UnAuthorizedException extends Error {
    constructor(
        message: string,
        public code: number
    ) {
        super(message);
        this.name = 'NotAuthorizedExeption';
    }
}

export default UnAuthorizedException;
